import request from '@/network/http'

export function deleteCheckupObjectTypeInfo(data) {
    return request({
        url: 'Checkup/CheckupObjectType/deleteCheckupObjectTypeInfo',
        method: 'post',
        data
    })
}

export function getCheckupObjectTypeDetail(data) {
    return request({
        url: 'Checkup/CheckupObjectType/getCheckupObjectTypeDetail',
        method: 'post',
        data
    })
}

export function saveCheckupObjectTypeInfo(data) {
    return request({
        url: 'Checkup/CheckupObjectType/saveCheckupObjectTypeInfo',
        method: 'post',
        data
    })
}

export function getCheckupObjectTypeList(data) {
    return request({
        url: 'Checkup/CheckupObjectType/getCheckupObjectTypeList',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/apis/checkObj.js